type TFn = (key: string) => string;

export function isNegotiablePrice(price: unknown): boolean {
  if (price === null || price === undefined) return true;
  if (typeof price === 'string') {
    const trimmed = price.trim();
    if (trimmed === '') return true;
    const n = Number(trimmed);
    return Number.isNaN(n) || n <= 0;
  }
  if (typeof price === 'number') {
    return !Number.isFinite(price) || price <= 0;
  }
  return true;
}

export function negotiableLabel(t?: TFn): string {
  if (t) {
    const translated = t('common.negotiable');
    if (translated && translated !== 'common.negotiable') return translated;
  }
  return 'قابل للتفاوض';
}

export function formatAdPrice(price: unknown, t?: TFn, suffix?: string): string {
  if (isNegotiablePrice(price)) return negotiableLabel(t);
  return suffix ? `${price}${suffix}` : `${price}`;
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  return new Date(value).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
